import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { set } from "lodash";

interface InitialState {
    schedulelist: []; 
}

const initialState: any = {
    schedulelist: [],
    edit:false,
    schedule_scan_id:null
};

const Schedule_Slice = createSlice({
  name: "schedulelist",
  initialState,
  reducers: {
    setScheduleList: (state, action: PayloadAction<any>) => {
      state.schedulelist = action.payload;
    },
    setEdit: (state, action: PayloadAction<any>) => {
      state.edit = action.payload.edit;
      state.schedule_scan_id = action.payload.schedule_scan_id;
    },  
    // Add other reducers as needed
  
  },
  
});

export const { setScheduleList,setEdit} = Schedule_Slice.actions;
export default Schedule_Slice.reducer;